/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstylenorthwest4Inputs */



/**
* | output |
* | --- |
* | "Sharp Teaser" |
*
* @param {Personalityhumorstylenorthwest4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstylenorthwest4 = /** @type {((inputs?: Personalityhumorstylenorthwest4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstylenorthwest4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sharp Teaser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Chistoso mordaz")
	return /** @type {LocalizedString} */ ("Подколист")
});
export { personalityhumorstylenorthwest4 as "personalityHumorStyleNorthWest" }